/**
 * Resolve a product image URL from either legacy images.edges or media.nodes.
 */
export function getProductImageUrl(productNode) {
  if (!productNode) return "";

  if (typeof productNode.image === "string" && productNode.image) {
    return productNode.image;
  }

  if (productNode.image?.url || productNode.image?.src) {
    return productNode.image.url || productNode.image.src;
  }

  return (
    productNode.images?.edges?.[0]?.node?.src ||
    productNode.images?.edges?.[0]?.node?.url ||
    productNode.media?.nodes?.find((node) => node?.image?.url)?.image?.url ||
    ""
  );
}

export function getProductImageAlt(productNode) {
  if (!productNode) return "";

  return (
    productNode.tooltip ||
    productNode.images?.edges?.[0]?.node?.altText ||
    productNode.media?.nodes?.find((node) => node?.image?.url)?.alt ||
    ""
  );
}
